import { Injectable, inject } from '@angular/core';
import { Store } from '@ngrx/store';

import { AppState } from '../../core/store/app.state';
import { openCartSidebar, closeCartSidebar } from '../../core/store/cart/cart.actions';
import { CartFacade } from '../../core/store/cart/cart.facade';
import { GtmService, Ga4Item } from '../../core/services/gtm.service';

import { SidebarService } from './sidebar.service';

@Injectable({
  providedIn: 'root'
})
export class CartService {
  private sidebarService = inject(SidebarService);
  private store = inject(Store<AppState>);
  private cart = inject(CartFacade);
  private gtm = inject(GtmService);

  toggleCartSidebar() {
    this.store.dispatch(openCartSidebar());
    this.sidebarService.openSidebar();
    this.cart.getCartItems().subscribe(items => {
      const gaItems: Ga4Item[] = (items || []).map(it => ({
        item_id: it.product?.sku || it.product?.uuid || it.product?.id,
        item_name: it.product?.name,
        item_category: it.product?.categories?.[0]?.name,
        item_variant: it.selectedVariation?.name,
        price: it.selectedVariation?.salesPrice ?? it.selectedVariation?.price ?? it.product?.salesPrice ?? it.product?.price ?? 0,
        quantity: it.quantity
      }));
      const value = gaItems.reduce((acc, i) => acc + (i.price ?? 0) * (i.quantity ?? 1), 0);
      this.gtm.viewCart(gaItems, value);
    }).unsubscribe();
  }

  closeCartSidebar() {
    this.store.dispatch(closeCartSidebar());
    this.sidebarService.closeSidebar();
  }
}
